<template>
  <header
    class="w-full h-24 max-w-full z-50 flex items-center justify-between top-0"
  >
    <div class="w-full flex items-center justify-between">
      <LocalizedLink
        class="w-full h-full"
        to="/"
        v-if="location === '/privacy-policy'"
      >
        <img src="/logo/saraf-logo-dark.svg" alt="logo" />
      </LocalizedLink>
      <div
        class="w-full flex items-center"
        v-if="location !== '/privacy-policy'"
      >
        <div id="header-breadcrumbs" />
        <nav class="flex w-full h-full items-center gap-8 justify-end">
          <slot name="before-links" />

          <slot name="after-links"></slot>
          <div class="flex-y-center gap-6">
            <CCoinInfo
              :amount="binanceBalance"
              icon="/binance-logo.svg"
              title="Binance"
              :loading="isRefreshed"
              @refresh-exchange="refreshExchange"
            />
            <CLanguageSwitcher />
            <Notification />
            <CProfileDropdown v-if="user?.id" :user="user" />
          </div>
        </nav>
      </div>
      <LocalizedLink v-else to="/auth/login">
        <CButton
          class="max-w-[92px]"
          icon="icon-log-out rotate-180"
          icon-position="left"
          :text="$t('sign_in')"
        />
      </LocalizedLink>
    </div>
  </header>
</template>
<script lang="ts" setup>
import CProfileDropdown from "@/layout/Dashboard/components/CProfileDropdown.vue";
import CLanguageSwitcher from "@/components/CLanguageSwitcher.vue";
import { useAuthStore } from "@/modules/Auth/stores";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import CButton from "@/components/Common/CButton.vue";
import CCoinInfo from "@/components/Common/CCoinInfo.vue";
import ApiService from "@/services/ApiService";
import Notification from "@/modules/Notification/components/Notification.vue";
import LocalizedLink from "@/components/CLocalizedLink.vue";

interface Props {
  links?: {
    title: string;
    to: string;
  }[];
  activeRoute?: string;
}

defineProps<Props>();

const route = useRoute();

const store = useAuthStore();

const isRefreshed = ref(false);

const user = computed(() => store?.user);
const binanceBalance = computed(
  () => store.user.unique_exchanges?.[0]?.usdt_balance,
);
const exchangeID = computed(() => store.user.unique_exchanges?.[0]?.id);
const location = computed(() => route?.path);

const refreshExchange = () => {
  isRefreshed.value = true;
  ApiService.post(`/bot/exchange/refresh/${exchangeID.value}/`)
    .then(async () => {
      await store.fetchUserData();
    })
    .catch((err: any) => {
      console.log(err);
    })
    .finally(() => {
      setTimeout(() => {
        isRefreshed.value = false;
      }, 300);
    });
};
</script>
